// Smooth open/close animation for the FAQ accordion (progressive enhancement
// over the native <details>/<summary> behaviour Dawn's collapsible-content uses).
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.collapsible-content .accordion > details');

  items.forEach((details) => {
    const content = details.querySelector('.accordion__content');
    const summary = details.querySelector('summary');
    if (!content || !summary) return;

    content.style.overflow = 'hidden';
    content.style.transition = 'height 0.25s ease';

    let animating = false;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (animating) return;
      animating = true;

      if (details.open) {
        // Closing: animate from current height to 0, then remove [open].
        const startHeight = content.getBoundingClientRect().height;
        content.style.height = `${startHeight}px`;
        requestAnimationFrame(() => {
          content.style.height = '0px';
        });
        content.addEventListener(
          'transitionend',
          () => {
            details.open = false;
            content.style.height = '';
            animating = false;
          },
          { once: true }
        );
      } else {
        // Opening: set [open] first so scrollHeight is measurable, animate from 0.
        details.open = true;
        const endHeight = content.getBoundingClientRect().height;
        content.style.height = '0px';
        requestAnimationFrame(() => {
          content.style.height = `${endHeight}px`;
        });
        content.addEventListener(
          'transitionend',
          () => {
            content.style.height = '';
            animating = false;
          },
          { once: true }
        );
      }
    });
  });
});
